import { Grid, GridProps, SxProps, Theme } from "@mui/material";
import { PropsWithChildren } from "react";
import CoverImage from "../../images/bg_img.svg";

interface Props {
  sx?: SxProps;
  containerProps: GridProps;
}

const pageStyle = (theme: Theme): SxProps => ({
  height: "100%",
  width: "100%",
  background: `url(${CoverImage}) no-repeat center center fixed`,
  backgroundSize: "cover",
  backgroundColor: theme.palette.background.grey,
});

const StyledPage = ({ sx, containerProps, children }: PropsWithChildren<Props>) => (
  <Grid container sx={(theme) => ({ ...pageStyle(theme), ...sx })} {...containerProps}>
    {children}
  </Grid>
);

export default StyledPage;
